import * as React from "react";
import {Alert as AlertComponent, Button, Col, Collapse, Container, Popover, PopoverBody, Row} from "reactstrap";
import PropTypes from 'prop-types';
import {HierarchyNavigation} from "./hierarchyNavigation";
import {userData} from "../../util/userData";
import {HttpRequest} from "../../util/http";
import * as _ from 'lodash';
import {TreeVisualization} from "./treeVisualization";


interface IExposeData {
  avids: IAvid[]
}
class exportData extends React.Component<IExposeData, any>{
  render() {
    return undefined;
  }
}


export class UserHierarchyManagementContainer extends React.Component<containerProps, containerState> {
  state: containerState = {
    trail: [],
    childAvids: [],
    dashboardsSelectedAvids: [],
    coachingFormsSelectedAvids: [],
    notificationsSelectedAvids: [],
    currentAvid: {
      id: undefined,
      text: 'ALL',
      prevLink: '',
      nextLink: 'Bankwide_0',
      hierarchyLevel: 'Bankwide',
      customer: '',
      childCount: 1,
      isDefault: true,
      isSelected: false,
      state: {
        selected: true,
        opened: false
      },
      children: []
    },
    nestedAvidObj: {
      id: undefined,
      text: 'ALL',
      state: {
        selected: true,
        opened: false
      },
      children: []
    },
    AvidsList: [],
    avidsGroupedByDistance: [],
    avidsGroupedByParent: [],
    defaultAvid: '',
    inheritCheckboxValue: true
  }
  constructor(props) {
    super(props);
    this.state.defaultAvid = (this.props.defaultAvid ? this.props.defaultAvid : '');
    this.state.inheritCheckboxValue = this.props.inheritCheckboxValue != false;

    this.toggleInherit = this.toggleInherit.bind(this);
    this.setCoachingFormAvids = this.setCoachingFormAvids.bind(this);
  }

  componentWillMount() {

  }

  componentDidMount() {
    // this.getBankwideAvid();
    // this.getAvids('Bankwide_0');
    this.getAvidsLegacy();

    window.addEventListener('refresh_notifications_tree', (e) => this.setCoachingFormAvids(e), false);
  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUpdate(nextProps, nextState) {

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.coachingFormsSelectedAvidsStr != this.state.coachingFormsSelectedAvidsStr && this.props.sectionName == 'Notifications') {
      const {AvidsList, coachingFormsSelectedAvidsStr} = this.state;
      let updated = AvidsList.map((avid) => {
        if (coachingFormsSelectedAvidsStr.includes(avid.id)) {
          avid.state.selected = true;
        } else avid.state.selected = false;
        return avid;
      });
      this.setState({AvidsList: updated});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('refresh_notifications_tree', null);
  }

  setCoachingFormAvids(e) {
    // get selected Avids from React Component
    let coachingFormSelectedAvids = e.detail.map((avid) => {
      if (avid.state.selected)
        return avid.id
    });
    coachingFormSelectedAvids = coachingFormSelectedAvids.filter((id) => id);
    this.setState({coachingFormsSelectedAvidsStr: coachingFormSelectedAvids});
  }

  getBankwideAvid() {
    const project = userData.getCurrentProject();
    let data = { current_project: project };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_bankwide_avid', { data, method })
      .then((res: IAvid) => {
        this.setState({
          currentAvid: res,
        });
        let trail = []
        trail.push({
          label: 'ALL',
          avid: res
        });
        this.setState({ trail: trail });
      });
  }

  getAvids(parentId: string) {
    const {childAvids} = this.state;
    const project = userData.getCurrentProject();
    let data = { current_project: project, parentId: parentId };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_avids', { data, method })
      .then((res: IAvid[]) => {
        let avids = res.map((avid) => {
          avid.isSelected = false;
          avid.isDefault = false;
          return avid;
        });
        this.setState({ childAvids: avids });
      });
  }

  getAvidsLegacy() {
    HttpRequest.fetch(`scripts/avids/avids_get_nested?user_id=${this.props.request_UserId}&type=${this.props.request_Type}&project=${this.props.request_projectId}`)
      .then((res: INestedAvid) => {
        let currentAvid: IAvid = res;
        currentAvid.isSelected = res.state.selected;

        let childrenAvids: IAvid[] = res.children.map((avid) => {
          avid.isSelected = avid.state.selected;
          avid.childCount = avid.children.length;
          return avid;
        });

        let trail = []
        trail.push({
          label: 'ALL',
          avid: res
        });

        let AvidList = this.flatten(res.children, x => x.children);
        AvidList.push(res);
        let groupedByDistance = _.groupBy(AvidList, 'distance');
        let groupedByParent = _.groupBy(AvidList, 'prevLink');
        if (this.props.defaultAvid)
          AvidList[AvidList.findIndex((avid) => avid.id == this.props.defaultAvid)].isDefault = true;
        this.setState({nestedAvidObj: res, currentAvid: currentAvid, childAvids: childrenAvids, trail: trail, AvidsList: AvidList, avidsGroupedByDistance: groupedByDistance, avidsGroupedByParent: groupedByParent});
      })
  }

  getAvid(legacyAvid: INestedAvid) {
    let newAvid: IAvid = legacyAvid;
    newAvid.isSelected = legacyAvid.state.selected;
    let childrenAvids: IAvid[] = legacyAvid.children.map((avid) => {
      avid.isSelected = avid.state.selected;
      avid.childCount = avid.children.length;
      return avid;
    });
    newAvid.childAvids = childrenAvids;

    return newAvid;
  }


  updateCurrentAvid(node: trailNode) {
    const { trail } = this.state;
    let currentAvid = this.getAvid(node.avid);
    this.setState({ currentAvid: currentAvid, childAvids: currentAvid.childAvids });
    this.updateDrillDownPath(node, trail.indexOf(node));
  }

  updateDrillDownPath(node: trailNode, drillDown: number) {
    let { trail } = this.state;
    let updatedTrail = [];
    const label = node.label;
    const avid = node.avid;
    if (drillDown == -1) {
      // add trail node to trail
      trail.push({ label: label, avid: avid });
    }
    if (drillDown >= 0) {
      // remove child trail nodes
      updatedTrail = trail.slice(0, drillDown + 1);
      trail = updatedTrail;
    }

    this.setState({ trail: trail });
  }

  toggleSelectAvid(avidId: string) {
    if (this.props.sectionName != 'Notifications' || (this.props.sectionName == 'Notifications' && this.state.coachingFormsSelectedAvidsStr.includes(avidId))) {
      const {AvidsList, avidsGroupedByParent} = this.state;
      const clickedAvid = AvidsList.find((avid) => avid.id == avidId);
      const isSelected = clickedAvid.state.selected;
      let selectParent = false;
      //  if it has children, all of them must reflect their parent status
      const listOfChildren = this.flatten(clickedAvid.children, x => x.children);
      const listOfChildrenIds = listOfChildren.map((avid) => {
        return avid.id;
      })

      // do we need to update the parent as well?
      if (avidsGroupedByParent.hasOwnProperty(clickedAvid.prevLink)) {
        const siblingAvids = avidsGroupedByParent[clickedAvid.prevLink];
        let siblingAvidIds = siblingAvids.map((avid) => {
          if (avid.state.selected) {
            return avid.id;
          }
        });
        siblingAvidIds = siblingAvidIds.filter((id) => id);
        selectParent = siblingAvidIds.length == siblingAvids.length - 1;

      }

      let updatedChildAvids = AvidsList.map((avid) => {
        if (avid.id == avidId || listOfChildrenIds.includes(avid.id)) {
          avid.state.selected = !isSelected;
        }
        if (avid.id == clickedAvid.prevLink)
          avid.state.selected = selectParent
        return avid;
      });

      this.setState({AvidsList: updatedChildAvids}, () => {
        if (this.props.sectionName == 'Coaching Forms') {
          const refreshSelectedAvids = new CustomEvent('refresh_notifications_tree', {detail: updatedChildAvids});
          window.dispatchEvent(refreshSelectedAvids);
        }
      });
    }
  }

  setDefaultAvid(selctedAvid: IAvid) {
    // TODO: Need to determine how to set initial default Avid if none is provided
    const { defaultAvid } = this.state;
    let updatedDefaultAvid = defaultAvid;

    if (selctedAvid.state.selected) {
      const {childAvids} = this.state;
      let updatedChildAvids = childAvids.map((avid) => {
        if (avid.id == selctedAvid.id) {
          avid.isDefault = true;
          updatedDefaultAvid = avid.id;
        } else {
          avid.isDefault = false
        }
        return avid;
      });

      this.setState({childAvids: updatedChildAvids, defaultAvid: updatedDefaultAvid});
    }
  }

  flatten(xs, childSelector) {
    return xs.reduce((acc, x) => {
      acc = acc.concat(x);
      let children = childSelector(x);
      if (children) {
        acc = acc.concat(this.flatten(children, childSelector));
      }
      return acc;
    }, []);
  }

  toggleInherit() {
    this.setState({inheritCheckboxValue: !this.state.inheritCheckboxValue});
  }

  render() {
    const {childAvids, AvidsList, currentAvid, trail, avidsGroupedByDistance, inheritCheckboxValue} = this.state;
    const {sectionName, inheritCheckbox, inheritMessage} = this.props;
    return (
      <div>
        <Row>
          <Col sm={3}>
            <div style={{padding: '15px 0px'}}><h5>Hierarchy Access - {sectionName}</h5></div>
          </Col>
          <Col sm={6}>
            {inheritCheckbox &&
            <p style={{padding: '15px 0px'}}>
                <input type="checkbox" id={this.props.checkboxInputName} checked={inheritCheckboxValue} onChange={() => this.toggleInherit()} style={{position: 'absolute', left: '-9999px', opacity: 0}}/>
                <label htmlFor={this.props.checkboxInputName} className='text-muted'>{inheritMessage}</label>
            </p>
            }
            <Collapse isOpen={!inheritCheckboxValue}>
              <HierarchyNavigation
                childAvids={childAvids}
                AvidsList={AvidsList}
                currentAvid={currentAvid}
                trail={trail}
                updateCurrentAvid={(avid) => this.updateCurrentAvid(avid)}
                toggleSelectAvid={(avidId) => this.toggleSelectAvid(avidId)}
                setDefaultAvid={(selectedAvid) => this.setDefaultAvid(selectedAvid)}
              />
            </Collapse>
          </Col>
          <Col sm={3}>
            <Collapse isOpen={!inheritCheckboxValue}>
              <TreeVisualization
                AvidsList={AvidsList}
                avidsGroupedByDistance={avidsGroupedByDistance}
                setDefaultAvid={(selectedAvid) => this.setDefaultAvid(selectedAvid)}
              />
            </Collapse>
          </Col>
        </Row>
      </div>
    );
  }
}
